module.exports = __webpack_public_path__ + "static/media/map_sm.03f950a4.png";